<template>
  <span id="app" class="dtable w100">
    <router-view class=""/>
        <BrowserIdentifierHandler></BrowserIdentifierHandler>
        <KeyboardCodeHandler></KeyboardCodeHandler>
        <HealthChecker/>
        <SettingSetter/>
        <AppVersion/>
        <Alert/>


  </span>
</template>


<script>
  import i18n from '@/i18n';
  import KeyboardCodeHandler from '@/components/KeyboardCodeHandler.vue';
  import BrowserIdentifierHandler from '@/components/BrowserIdentifierHandler.vue';
  import HealthChecker from '@/components/HealthChecker.vue';
  import SettingSetter from '@/components/SettingSetter.vue';
  import AppVersion from '@/components/AppVersion';
  import Alert from '@/components/Alert';

  export default {
    data() {
      return {
        lang: "en",
      };
    },
    watch: {
      lang: function (newLang, oldLang) {
        i18n.locale = newLang;
      }
    },
    mounted() {
      window.db = {};
      window.db.select = function(){
          console.log("ERROR: window.db.select USING")
      };
    },

    methods: {},
    components: {
      KeyboardCodeHandler,
      BrowserIdentifierHandler,
      HealthChecker,
      SettingSetter,
      AppVersion,
      Alert,
    }
  }
</script>

<style lang="scss">
  @import 'assets/app.css';
  @import 'assets/SZBAdmin.css';
  @import 'assets/SZBKit.css';

  @import 'assets/vendor/sufee-admin-dashboard/assets/css/normalize.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/css/bootstrap.min.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/css/font-awesome.min.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/css/themify-icons.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/css/flag-icon.min.css';
  // Not loading, broken maybe?
  // @import 'assets/vendor/sufee-admin-dashboard/assets/css/cs-skin-elastic.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/scss/style.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/css/fonts.css';
  @import 'assets/css/untitled-font-2.css';

  //
  // #app {
  //   font-family: 'Avenir', Helvetica, Arial, sans-serif;
  //   -webkit-font-smoothing: antialiased;
  //   -moz-osx-font-smoothing: grayscale;
  //   text-align: center;
  //   color: #2c3e50;
  // }
  // #nav {
  //   padding: 30px;
  //   a {
  //     font-weight: bold;
  //     color: #2c3e50;
  //     &.router-link-exact-active {
  //       color: #42b983;
  //     }
  //   }
  // }
  .h40p {
    height: 40px;
  }

  .w100 {
    width: 100%;
  }

  .w100i {
    width: 100% !important;
  }

  .dtable {
    display: table;
  }

  .dtablerow {
    display: table-row;
  }

  .dtablecell {
    display: table-cell;
  }

  .pointer {
    display: table-cell;
  }

  body .navbar .navbar-nav li > a {
    padding: 0;
    font-size: 13px;
    line-height: 24px;
  }

  body .navbar .menu-title {
    padding: 0;
  }

  .infoblock {
    background-color: #f8f8e4;
    padding: 10px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .input-group-addon-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .input-group-addon-success {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
  }

  .disabledFunction {
    position: relative;
    top: 0;
    left: 0;
  }

  .disabledFunction:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.7);
  }

  /* Form errors */
  body [aria-invalid="true"] {
    border-color: #dc3545;
  }

  body .font-size-small {
    font-size: small
  }

  body .font-size-smaller {
    font-size: smaller
  }

  body .dataTableContent {
    overflow: auto;
  }

  /*
  fContainer -- konténer
      fColumn -- olyan class ami szükséges az összes konténer, és a layout-ok közé a működéshez
          fHead -- layout header, NEM nyúlik az oldal magasságához
          fContent -- layout content, IGEN, nyúlik az oldal magasságához
          fFix -- layout header, footer, és bármi amit fix-re akarunk, tehát NEM nyúlik az oldal magasságához
  fFootHck -- Footer hack, ami ahhoz kell, hogy a nagyobbra nyitásnál is úgy nézzen ki, mint ha növekedne az ablak.
          Csak teljes képernyős módra jó, és csak akkro ha card elem alatti footerről van szó.
  fCard -- A korábbi fFootHck elem card-ja, ami alá fehéret teszünk, mintha az adott card nyúlna
  */

  /* alap layoutok */

  @media (max-width: 575.99px) {
    body {
      font-size: 14px;
    }

    body .fContainer {
      position: absolute;
      /*height: 100%;*/
      width: 95%;

    }
    body .fContainer.mw90 {
      position: absolute;
      /*height: 100%;*/
      width: 90%;

    }

    body .fContainer {
      /*position: absolute;*/
      /*height: 100%;*/
      /*width: 100%;*/
      display: flex;
      flex-direction: column;
    }
    body .fContainer .fColumn {
      flex-direction: column;
      display: flex;
      flex-shrink: 1;
    }
    body .fContainer .fHead {
      flex-shrink: 0;
    }
    body .fContainer .fContent {
      overflow-y: auto;
      overflow-x: auto;
    }
    body .fContainer .fFix {
      flex-shrink: 0;
    }
    /* / alap layoutok */

    /* fFootHck layoutok */
    body .fContainer .fFootHck {
      flex-shrink: 0;
      position: relative;
      top: 0;
      left: 0;
    }
    body .fContainer .fFootHck > div {
      position: fixed;
      bottom: 0;
      width: 100%;
      left: 0;
      padding: 0 20px;
    }
    body .fContainer .fFootHck:after {
      content: "";
      display: block;
      height: 72px;
      /*border: red dashed 1px;*/
    }
    body .fContainer .fFootHck .fFootHckExt > div {
      border: 1px solid rgba(0, 0, 0, .125);
    }
    body .fContainer .fFootHckExt:after {
      content: "";
      display: block;
      height: 15px;
      background-color: #f1f2f7;
      /*border: red dashed 1px;*/
    }
    /* Ez a scroller hez kötődő paddingokat kezeli, hogy a scroller illeszkedjen a külső div-hez */
    body .fContainer .pt-15 {
      padding-top: 15px;
    }
    body .fContainer .pb-15 {
      padding-bottom: 15px;
    }
    body .fContainer .pt-0 {
      padding-top: 0;
    }
    body .fContainer .pb-0 {
      padding-bottom: 0;
    }

    @media (max-width: 1368px) {
      body .fContainer .fFootHckExt:after {
        height: 15px;
      }
      body .fContainer .fFootHck > div {
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        padding: 0 15px;
      }
    }
    /* Ez folyatja a fehér hátteret lefelé */
    /*body .fContainer .fCard{*/
    /*!*border-bottom:none;*!*/
    /*border-bottom-width:0;*/
    /*border-right:1px solid rgba(0,0,0,.125);*/
    /*border-left:1px solid rgba(0,0,0,.125);*/
    /*}*/
    /*body .fContainer .fCard:after {*/
    /*content: "";*/
    /*width: 100%;*/
    /*height: 2000px;*/
    /*position: absolute;*/
    /*top: 0;*/
    /*left: 0;*/
    /*!*border: 1px solid red;*!*/
    /*background-color: white;*/
    /*z-index: -1;*/
    /*}*/
    /* / Ez folyatja a fehér hátteret lefelé */
    /* / fFootHck layoutok */

    /* Ez a scroller szélesítés */
    .dataTables_scrollBody::-webkit-scrollbar,
    body .fContainer .fContent::-webkit-scrollbar {
      width: 30px;
      height: 30px;
    }
    .dataTables_scrollBody::-webkit-scrollbar-track,
    body .fContainer .fContent::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #eee;
    }
    .dataTables_scrollBody::-webkit-scrollbar-thumb,
    body .fContainer .fContent::-webkit-scrollbar-thumb {
      background-color: #ccc;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    }
    /* / Ez a scroller szélesítés */

  }


  /* SELLING */
  .w100 {
    width: 100%;
  }
  .w0 {
    width: 0%;
  }
  .w1 {
    width: 1%;
  }
  .w50 {
    width: 50%;
  }
  .w49 {
    width: 49%;
  }
  .mr15{
    margin-right: 15px;
  }

  .dtable {
    display: table;
  }

  .dtablerow {
    display: table-row;
  }

  .dtablecell {
    display: table-cell;
  }
  .dinlineblock {
    display: inline-block;
  }
  .valigntop{
    vertical-align:top;
  }
  .valignbottom{
    vertical-align:bottom;
  }

  .pointer {
    /*display: table-cell;*/
    cursor: pointer;
  }
  .nav-tabs a.active.pointer, .btn_delrow ,.btn_keyboard{
    cursor: pointer;
  }
  /*.cursor {*/
  /*cursor: pointer;*/
  /*}*/
  body .form-group {
    margin-bottom: 0.3rem;
  }

  .extensionLine:after {
    content: "";
    display: block;
    width: 100%;
    height: 2px;
    background-color: rgba(80, 80, 80, 0.1);
    position: relative;
    top: 0;
    left: 0;
  }

  .dataTables_scroll tr td, .dataTables_scroll tr th {
    white-space: nowrap;
  }

  /* header menu container */
  body .right-panel header.header {
    padding: 10px 5px 10px 5px;
  }

  @media (max-width: 1368px) {
    body .right-panel header.header {
      padding: 10px 1px 10px 15px;
    }
  }

  /* inputok 1px-es hide-olása */
  .d-none-x {
    width: 1px;
    height: 1px;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .d-none-nf {
    width: 1px;
    height: 1px;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  /* input focus-ban mutassuk */
  .d-none-nf:focus {
    width: inherit;
    height: inherit;
    opacity: inherit;
    position: inherit;
    top: inherit;
    left: inherit;
  }

  /**/
  .receiptDisplayContainer .table td, .receiptDisplayContainer .table th {
    padding: 0 .15rem;
    border-top: none;
    border-bottom: 1px solid #dee2e6;
    vertical-align: bottom;
  }

  .receiptDisplayContainer .table td.price {
    white-space: nowrap;
    width: 15%;
  }

  .receiptDisplayContainer .table td.icons {
    border: 0 none;
    vertical-align: bottom;
  }

  .iconDefault {
    /* font-size: 32px; */
    width: 1px;
    height: 51px;
  }
  /* Mass termékek */
  .elementContainer .icon {
    padding: 0 3px;
    display: inline-block;
    vertical-align: middle;
    height: 100%;
    font-size: 34px;
    width: 40px;
    /*width: 48px;*/
  }
  /* Barcode-os termékek */
  .elementContainer .iconDefault.iconProduct {
    /*padding: 0 3px;*/
    /*min-width: 39px;*/
    vertical-align: top;
    font-size: 26px;
    text-align: center;
  }

  .elementContainer .textLabel {
    /* display: inline-block; */
    /* height: 100%; */
    margin: 3px;
    padding: 2px;
    /* padding: 13px 50px 13px 2px; */
    /* position: absolute; */
    /* top: -13px; */
    /* vertical-align: middle; */
    text-align: center;
    width: 100%;
    vertical-align: middle;
    /* margin: 0 !important; */
    /* font-size: 16px; */
    /* margin: 0 auto; */
  }

  .elementContainer .count {
    display: none;
    position: absolute;
    bottom: 0;
    /*right: 5px;*/
    font-weight: bold;
    /*position: absolute;*/
    /*bottom: 0px;*/
    /*left: 0px;*/
    /*font-weight: bold;*/
    right: 5px;
    line-height: 14px;
    /* outline: 1px solid red; */
    background-color: white;
    padding: 1px 5px;
  }
  .elementContainer .price {
    position: absolute;
    bottom: 0px;
    right: 0px;
    font-weight: bold;
    line-height: 14px;
    /* outline: 1px solid red; */
    background-color: white;
    padding: 0px 5px;
    border-top-left-radius: 3px;
  }

  .elementContainer {
    display: block;
    text-align: justify;
  }

  .elementContainer:after {
    content: '';
    display: block;
    clear: both;
  }

  .box {
    /* display: inline-block; */
    /* display: grid; */
    /* border: 1px solid grey; */
    float: left;
    /* text-align: center; */
  }

  /*.box:before {*/
  /*content: "";*/
  /*display: inline-block;*/
  /*vertical-align: middle;*/
  /*height: 0;*/
  /*}*/
  .box.box-x {
    /*min-width: 172px;*/
    height: 3.3em;
    margin: 0 7px 7px 0;
    overflow: hidden;
    border-radius: 4px;
    border-color: #ccc;
    border-top: 4px solid #ccc;
    /* text-align: left; */
    /*width: 5%;*/
    display: table-row;
    border: 1px solid #ccc;
    /* height: 100%; */
  }

  .box.box-x > span {
    display: table-cell;
  }

  /*
  zöld #f3faf4  f9fcf9
kek #f1f7ff f8fbff
szürke #f8f8f9  fbfbfc
sarga #fffbf1 fffdf8
kek  		 f8fcfd
piros  		fef9f9

*/
  .sellinone .elementPack-1 {
    /*border-top: 3px solid grey;*/
    border-top: 3px solid #218838;
    background-color: #f9fcf9;
  }

  /*.sellinone .box.elementPack {*/
  /*!*Szürke*!*/
  /*!*border-top: 3px solid grey;*!*/
  /*!*background-color: #fbfbfc;*!*/

  /*border-top: 3px solid #007bff;*/
  /*background-color: #f8fcfd;*/

  /*}*/
  .sellinone .box.elementPack-3
  ,.sellinone .box.elementPack-2
  ,.sellinone .box.elementPack-3
  ,.sellinone .box.elementPack-4
  ,.sellinone .box.elementPack-5
  ,.sellinone .box.elementPack-6
  ,.sellinone .box.elementPack-7
  ,.sellinone .box.elementPack-8
  {
    border-top: 3px solid #007bff;
    background-color: #f8fcfd;

    /*border-top: 3px solid #e0a800;*/
    /*background-color: #fffdf8;*/
  }
  .sellinone .box.elementType-category {
    /*border-top: 3px solid #007bff;*/
    /*background-color: #f8fcfd;*/

    border-top: 3px solid #ffc107;
    background-color: #fff0be;


    /*background-color: #ffc107;*/
  }


  /* Element displaytype modify classes */
  .box.box-x.displaytype1{
    min-width: 250px;
  }
  .box.box-x.displaytype1 .textLabel{
    text-align: left;
    padding: 0 5px;
  }


  /* szélesség megadása felbontásonként */
  @media (min-width: 1265px) {
    .box.box-x {
      width: 10%;
      min-width: 148px
    }
    /*.box.box-x.displaytype1{*/
    /*width: 47%;*/
    /*}*/


  }
  @media (max-width: 1440px) {
    .box.box-x {
      width: 10%;
      /*min-width: 148px*/
    }
  }

  @media (max-width: 1265px) {
    .box.box-x {
      /*width: 24%;*/
      width: 23%;
      /*min-width: 150px*/
    }
  }

  @media (max-width: 1022px) {
    .box.box-x {
      /*width: 32%;*/
      width: 31%;
      /*min-width: 150px*/
    }
  }

  @media (max-width: 780px) {
    .box.box-x {
      /*width: 48%;*/
      width: 47%;
      min-width: 148px;
    }
  }

  @media (max-width: 584px) {
    .box.box-x {
      /*width: 100%;*/
      width: 100%;
    }
  }

  .btn-box {
    position: relative;
    top: 0;
    left: 0;
    cursor: pointer;
  }

  .btn-box label {
    display: block;
    /*width: 100%;*/
    /*height: 100%;*/
    margin: 0;
    /*padding: 0;*/
    /*position: absolute;*/
    /*top: 0;*/
    /*left: 0;*/
    cursor: pointer;
  }

  .header-menu a.linkToTemplate button {
    margin: 2px 0;
  }
  .header-menu .spanLinkToTemplate {
    margin: 0 2px 0 2px;
  }

  .btn.border-sel {
    /*border-color: #ccc;*/
    border-radius: .25rem;
  }

  .logContainer {
    font-size: 12px;
    margin-left: 5px;
    position: fixed;
    bottom: 0;
  }

  body [aria-invalid="true"]{
    border-color: #dc3545;
  }
  body [aria-invalid="true"]:focus{
    border-color: #dc3545;
  }

  .paddingLeftdef {padding-left: 20px;}
  .paddingLeft5 {padding-left: 5px;}
  .paddingLeft10 {padding-left: 10px;}
  .paddingLeft15 {padding-left: 15px;}
  .paddingLeft20 {padding-left: 20px;}
  .paddingLeft25 {padding-left: 25px;}
  .paddingLeft30 {padding-left: 30px;}
  .paddingLeft35 {padding-left: 35px;}
  .paddingLeft40 {padding-left: 40px;}
  .paddingLeft45 {padding-left: 45px;}
  .paddingLeft50 {padding-left: 50px;}
  .paddingLeft55 {padding-left: 55px;}
  .paddingLeft60 {padding-left: 60px;}
  .paddingLeft65 {padding-left: 65px;}
  .paddingLeft70 {padding-left: 70px;}
  .paddingLeft75 {padding-left: 75px;}

  .paddingRightdef {padding-right: 20px;}
  .paddingRight5 {padding-right: 5px;}
  .paddingRight10 {padding-right: 10px;}
  .paddingRight15 {padding-right: 15px;}
  .paddingRight20 {padding-right: 20px;}
  .paddingRight25 {padding-right: 25px;}
  .paddingRight30 {padding-right: 30px;}
  .paddingRight35 {padding-right: 35px;}
  .paddingRight40 {padding-right: 40px;}
  .paddingRight45 {padding-right: 45px;}
  .paddingRight50 {padding-right: 50px;}
  .paddingRight55 {padding-right: 55px;}
  .paddingRight60 {padding-right: 60px;}
  .paddingRight65 {padding-right: 65px;}
  .paddingRight70 {padding-right: 70px;}
  .paddingRight75 {padding-right: 75px;}

  .paddingTopdef {padding-top: 20px;}
  .paddingTop5 {padding-top: 5px;}
  .paddingTop10 {padding-top: 10px;}
  .paddingTop15 {padding-top: 15px;}
  .paddingTop20 {padding-top: 20px;}
  .paddingTop25 {padding-top: 25px;}
  .paddingTop30 {padding-top: 30px;}
  .paddingTop35 {padding-top: 35px;}
  .paddingTop40 {padding-top: 40px;}
  .paddingTop45 {padding-top: 45px;}
  .paddingTop50 {padding-top: 50px;}
  .paddingTop55 {padding-top: 55px;}
  .paddingTop60 {padding-top: 60px;}
  .paddingTop65 {padding-top: 65px;}
  .paddingTop70 {padding-top: 70px;}
  .paddingTop75 {padding-top: 75px;}


  .printerFontSizedef{        font-size: 16px;}
  .printerFontSize6{        font-size: 6px;}
  .printerFontSize8{         font-size: 8px;}
  .printerFontSize10{        font-size: 10px;}
  .printerFontSize11{        font-size: 11px;}
  .printerFontSize12{        font-size: 12px;}
  .printerFontSize13{        font-size: 13px;}
  .printerFontSize14{        font-size: 14px;}
  .printerFontSize14{        font-size: 16px;}
  .printerFontSize18{        font-size: 18px;}
  .printerFontSize22{        font-size: 22px;}
  .printerFontSize28{        font-size: 28px;}
  .printerFontSize34{        font-size: 34px;}
  .printerFontSize55{        font-size: 55px;}

  .bgWhite{        background-color: white;}




  .TouchKeyboardBp .keyboard {
    width: 100%;
    margin: 0;
  }
  .TouchKeyboardBp .keyboard .line {
    display: flex;
    justify-content: space-around;
  }
  .TouchKeyboardBp .keyboard .line:not(:last-child) {
    margin-bottom: 0.5em;
  }
  .TouchKeyboardBp .keyboard .key {
    flex: 40;
    /*height: 2.2em;*/
    height: 2.7em;
    line-height: 2.2em;
    overflow: hidden;
    vertical-align: middle;
    border: 1px solid #ccc;
    color: #333;
    background-color: #fff;
    /*box-shadow: 0px 2px 2px rgba(0, 0, 0, .6);*/
    border-radius: 0.35em;
    font-size: 1.25em;
    text-align: center;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
  }
  .TouchKeyboardBp .keyboard .key:not(:last-child) {
    margin-right: 0.5em;
  }
  .TouchKeyboardBp .keyboard .key.backspace {
    /*background-image: url("./icons/backspace.svg");*/
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 35%;
  }
  .TouchKeyboardBp .keyboard .key.half {
    flex: 20;
  }
  .TouchKeyboardBp .keyboard .key.control {
    color: #fff;
    background-color: #7d7d7d;
    border-color: #656565;
  }
  .TouchKeyboardBp .keyboard .key.control:hover {
    color: #fff;
    background-color: #8d8d8d;
    border-color: #656565;
  }
  .TouchKeyboardBp .keyboard .key.featured {
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
  }
  .TouchKeyboardBp .keyboard .key.featured:hover {
    color: #fff;
    background-color: #438ac7;
    border-color: #2e6da4;
  }
  .TouchKeyboardBp .keyboard .key.dbplus.featured {
    color: #fff;
    background-color: #dc3545;
    border-color: #bc1525;
  }
  .TouchKeyboardBp .keyboard .key.dbplus.featured:hover {
    color: #fff;
    background-color: #ec4555;
    border-color: #cc2535;
  }
  .TouchKeyboardBp .keyboard .key:hover {
    color: #333;
    background-color: #d6d6d6;
    border-color: #adadad;
  }
  .TouchKeyboardBp .keyboard .key:active {
    transform: scale(0.98);
    color: #333;
    background-color: #d4d4d4;
    border-color: #8c8c8c;
  }
  .TouchKeyboardBp .keyboard .key.activated {
    color: #fff;
    background-color: #5bc0de;
    border-color: #46b8da;
  }
  .TouchKeyboardBp .keyboard .key {
    color: #aaa;
    background: #eff0f2;
    border-radius: 0;
    border-top: 1px solid #ddd;

    /*box-shadow: inset 0 0 25px #e8e8e8, 0 1px 0 #c3c3c3, 0 2px 0 #c9c9c9, 0 2px 3px #333;*/
    /*text-shadow: 0px 1px 0px #f5f5f5;*/
  }
  .TouchKeyboardBp .keyboard .key.control {
    /*box-shadow: 0 1px 0 #c3c3c3, 0 2px 0 #c9c9c9, 0 2px 3px #333;*/
    /*text-shadow: 0px 1px 0px #777;*/
  }
  .TouchKeyboardBp .keyboard .key:hover {
    color: #aaa;
    /*background-color: inherit;*/
    border-color: inherit;
  }
  .TouchKeyboardBp .keyboard .key:active {
    color: #888;
    background: #ebeced;
    transform: translateY(3px);
    /*box-shadow: inset 0 0 25px #ddd, 0 0 3px #333;*/
    border-top: 1px solid #eee;
  }
  .TouchKeyboardBp .keyboard .placeholder {
    flex: 19;
    height: 2.2em;
    line-height: 2.2em;
  }
  .TouchKeyboardBp .keyboard .placeholder:not(:last-child) {
    margin-right: 0.5em;
  }
  .TouchKeyboardBp .keyboard:before, .TouchKeyboardBp .keyboard:after {
    content: "";
    display: table;
  }
  .TouchKeyboardBp .keyboard:after {
    clear: both;
  }

  .TouchKeyboardBp .keyboard .key:not(.control):not(.accept){
    border: 1px solid #878787;
    color: #878787;
    background: linear-gradient(180deg, rgba(247,247,247,1) 0%, rgba(234,234,234,1) 50%, rgba(221,221,221,1) 100%);
  }
  .TouchKeyboardBp .keyboard .key:not(.control):not(.accept):hover{
    border: 1px solid #878787;
    color: #878787;
    background: linear-gradient(0deg, rgba(247,247,247,1) 0%, rgba(234,234,234,1) 50%, rgba(221,221,221,1) 100%);
  }
  .TouchKeyboardBp .keyboard .key.featured.accept{
    /*background-color: #28a745;*/
    border-color: #28a745;
    line-height: 2.8em;
    background: #28a745;
  }
  .TouchKeyboardBp .keyboard .key.featured.accept:hover{
    /*background-color: #28a745;*/
    border-color: #38b755;
    line-height: 2.8em;
    background: #38b755;
  }
  .TouchKeyboardBp .keyboard .key.accept:before {
    /*content: "O";*/
    content: "\f00c";
    display: block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 33px;
    /*font-size: inherit;*/
    text-rendering: auto;
    padding :5px 0 0 0;
  }


  .TouchKeyboardBp .keyboard .key.featured.next{
    /*background-color: #28a745;*/
    border-color: #28a745;
    line-height: 2.8em;
    background: #28a745;
  }
  .TouchKeyboardBp .keyboard .key.featured.next{
    /*background-color: #28a745;*/
    border-color: #38b755;
    line-height: 2.8em;
    background: #38b755;
  }
  .TouchKeyboardBp .keyboard .key.next:before {
    /*content: "O";*/
    content: "\f00c \f101";
    display: block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 33px;
    /*font-size: inherit;*/
    text-rendering: auto;
    padding :5px 0 0 0;
  }
  /*.TouchKeyboardBp .keyboard .key.featured.cursorleft{*/
  /*border-color: #38b755;*/
  /*line-height: 2.8em;*/
  /*background: #38b755;*/
  /*}*/
  .TouchKeyboardBp .keyboard .key.cursorleft:before {
    content: "\f060";
    display: block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 33px;
    text-rendering: auto;
    padding :5px 0 0 0;
    /*font-size: inherit;*/
  }
  /*.TouchKeyboardBp .keyboard .key.featured.cursorRight{*/
  /*border-color: #38b755;*/
  /*line-height: 2.8em;*/
  /*background: #38b755;*/
  /*}*/
  .TouchKeyboardBp .keyboard .key.cursorRight:before {
    content: "\f061";
    display: block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 33px;
    text-rendering: auto;
    padding :5px 0 0 0;
    /*font-size: inherit;*/
  }


  .TouchKeyboardBp .keyboard .key.backspace {
    /*background-image: url("./icons/backspace.svg");*/
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 35%;
  }
  .TouchKeyboardBp .keyboard .key.backspace:before {
    /*content: "O";*/
    content: "\f060";
    display: block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 33px;
    /*font-size: inherit;*/
    text-rendering: auto;
    padding :5px 0 0 0;
  }
  .openKeyboard .vue-touch-keyboard-holder-inner.layout-n
  ,.openKeyboard .vue-touch-keyboard-holder-inner.layout-nplus
  ,.openKeyboard .vue-touch-keyboard-holder-inner.layout-ndbplus
  ,.openKeyboard .vue-touch-keyboard-holder-inner.layout-nn
  {
    max-width: 600px;
    margin: 0 auto;
    display: block;
  }

  .vue-touch-keyboard-holder.openKeyboard {
    padding: 130px 100px 0 100px;
  }
  .vue-touch-keyboard-holder.openKeyboard input{
    font-size: 2rem;
  }
  .input-group .custom-file.w100
  , .input-group .custom-select.w100
  , .input-group .form-control.w100{
    width: 100%;
  }

  @media (max-width: 800px) {
    .vue-touch-keyboard-holder.openKeyboard {
      padding: 65px 50px 0 50px;
    }
  }

</style>
